import { render, staticRenderFns } from "./mc-modul.vue?vue&type=template&id=74027680&scoped=true"
import script from "./mc-modul.vue?vue&type=script&lang=js"
export * from "./mc-modul.vue?vue&type=script&lang=js"
import style0 from "./mc-modul.vue?vue&type=style&index=0&id=74027680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74027680",
  null
  
)

export default component.exports